import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const Button = ({
  primary, default: def, link, success, info, danger, warning, icon,
  disabled,
  href,
  loading,
  className,
  underline,
  ...props
}) => {
  const classes = classNames('btn', className, {
    'btn-primary': primary,
    'btn-default': def,
    'btn-link': link,
    'btn-link--underline': link && underline,
    'btn-success': success,
    'btn-info': info,
    'btn-danger': danger,
    'btn-warning': warning,
    'icon-button': icon,
    'disabled': disabled,
  });

  if (href) {
    return <a href={href} className={classes} {...props} />;
  }
  return <button className={classes} {...props} disabled={disabled}/>;
};

Button.propTypes = {
  className: PropTypes.string,
  danger: PropTypes.bool,
  default: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.bool,
  info: PropTypes.bool,
  link: PropTypes.bool,
  loading: PropTypes.bool,
  primary: PropTypes.bool,
  success: PropTypes.bool,
  warning: PropTypes.bool,
  href: PropTypes.string,
  underline: PropTypes.bool,
};

export default Button;
